import React from 'react'
import PropTypes from 'prop-types'

const ArrowUpIcon = ({ width = 32, height = 21, color = 'black' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30.9132 19.4165C30.4734 19.9108 29.8769 20.1885 29.2549 20.1885C28.6329 20.1885 28.0364 19.9108 27.5966 19.4165L15.9858 6.36472L4.37512 19.4165C3.93274 19.8968 3.34023 20.1625 2.72522 20.1565C2.11022 20.1505 1.52191 19.8732 1.08702 19.3844C0.652123 18.8955 0.40544 18.2342 0.400095 17.5428C0.394751 16.8515 0.631176 16.1854 1.05845 15.6882L14.3275 0.772232C14.7674 0.277924 15.3639 0.000236999 15.9858 0.000237054C16.6078 0.000237108 17.2043 0.277924 17.6442 0.772233L30.9132 15.6882C31.353 16.1826 31.6 16.8532 31.6 17.5523C31.6 18.2515 31.353 18.922 30.9132 19.4165Z"
        fill={color}
      />
    </svg>
  )
}

ArrowUpIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

export default React.memo(ArrowUpIcon)
